import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <h1 style={{ color: 'red', fontWeight: 'bold', fontSize: '2rem' }}>
        Dashboard In Progress
      </h1>
    </div>
  );
};

export default Dashboard;
